export { default } from "memoize";
export * from "memoize";
